import { useState } from 'react';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastConfig {
  visible: boolean;
  message: string;
  type: ToastType;
}

export const useToast = () => {
  const [toastConfig, setToastConfig] = useState<ToastConfig>({
    visible: false,
    message: '',
    type: 'info'
  });

  const showToast = (type: ToastType, message: string) => {
    setToastConfig({
      visible: true,
      message,
      type
    });
  };

  const hideToast = () => {
    setToastConfig(prev => ({
      ...prev,
      visible: false
    }));
  };

  return {
    toastConfig,
    showToast,
    hideToast
  };
};
